function extractErrorMessage(error: unknown): string | undefined {
  if (error == null) {
    return undefined;
  }

  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === "string") {
    return error;
  }

  if (typeof error === "object") {
    const maybeMessage = (error as { message?: unknown }).message;
    if (typeof maybeMessage === "string") {
      return maybeMessage;
    }
  }

  return undefined;
}

export function useLoaderErrorMessage(error?: unknown): string | undefined {
  if (error == null) {
    return undefined;
  }

  if (Array.isArray(error)) {
    const messages = error.map((entry) => extractErrorMessage(entry)).filter(Boolean);

    if (messages.length === 0) {
      return undefined;
    }

    return messages.join(" ");
  }

  return extractErrorMessage(error);
}
